<template>
  <div class="image-link">
    <div class="link-container">
      <el-select v-model="link.isInnerPage" class="link-type">
        <el-option :label="$t('microSite.common.form.internalPageOption')" :value="true"></el-option>
        <el-option :label="$t('microSite.common.form.externalPageOption')" :value="false"></el-option>
      </el-select>
      <template v-if="link.isInnerPage">
        <el-select
          v-model="selectedPageId"
          class="link-page"
          :placeholder="$t('microSite.navigation.placeholder.selectInnerPage')"
          @change="handlePageChange">
          <el-option
            v-for="(item, index) in sitePages"
            :key="index"
            :label="item.metaInfo.title"
            :value="item.id">
          </el-option>
        </el-select>
        <el-select
          v-model="selectedModuleId"
          clearable
          class="link-module"
          :placeholder="$t('microSite.navigation.placeholder.selectInnerLink')"
          @change="handleModuleChange">
          <el-option
            v-for="(item, index) in pageModules"
            :key="index"
            :label="item.label"
            :value="item.value.id">
          </el-option>
        </el-select>
      </template>
      <el-input v-else v-model="link.url" class="link-path" :placeholder="$t('microSite.common.form.externalPagePlaceholder')"></el-input>
    </div>
    <el-checkbox v-model="link.openNewWindow">{{ $t('microSite.common.form.openInNewWindow') }}</el-checkbox>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import navigationModule from '../../modules/navigation/index'

export default {
  props: {
    link: Object
  },
  data () {
    return {
      pageModules: [],
      selectedPageId: null,
      selectedModuleId: null
    }
  },
  computed: {
    ...mapGetters('microSite', ['sitePages'])
  },
  created () {
    if (this.link.isInnerPage && this.link.url) {
      const url = this.link.url
      const pagePath = url.replace(/scrollin=\d*/g, '').replace(/&&/g, '&').replace(/\?$/, '')
      const selectedPage = _.find(this.sitePages, { path: pagePath })
      this.pageModules = selectedPage.renderData.children
        .filter(item => !item.skipMatch && item.tag !== navigationModule.name)
        .map(item => {
          const props = item.data.props
          return {
            label: props.name || props.title,
            value: item
          }
        })
      this.selectedPageId = selectedPage.id
      if (url.includes('scrollin=')) {
        const moduleId = parseInt(url.replace(/.*scrollin=(\d*).*/g, '$1'))
        if (moduleId) {
          this.selectedModuleId = moduleId
        }
      }
    }
  },
  methods: {
    handlePageChange (pageId) {
      const selectedPage = _.find(this.sitePages, { id: pageId })
      if (!selectedPage) {
        return
      }
      this.pageModules = selectedPage.renderData.children
        .filter(item => !item.skipMatch && item.tag !== navigationModule.name)
        .map(item => {
          const modules = require('../../modules/index')
          const props = item.data.props
          return {
            label: props.title || modules.getProjectItemTitle(item),
            value: item
          }
        })
      this.link.url = selectedPage.path
      this.selectedModuleId = null
    },
    handleModuleChange (moduleId) {
      let url = this.link.url.replace(/scrollin=\d*/g, '').replace(/&&/g, '&').replace(/\?$/, '')
      if (moduleId) {
        if (url.includes('?')) {
          url += `&scrollin=${moduleId}`
        } else {
          url += `?scrollin=${moduleId}`
        }
      }
      this.link.url = url
    }
  }
}
</script>

<style lang="scss" scoped>
.image-link {
  .link-container {
    margin-top: 10px;
    .link-type {
      margin-bottom: 10px;
      width: 190px;
      margin-right: 10px;
    }
    .link-page, .link-module {
      margin-bottom: 10px;
      width: 190px;
      margin-right: 10px;
    }
    .link-path {
      margin-bottom: 10px;
      width: 370px;
    }
  }
}
</style>
